import type { RootState } from '../../configuration/setup/store';
import type { SettingsSnapshot } from './tourSlice';

/**
 * Captures a fingerprint of all route-relevant settings at a point in time.
 * Used to detect whether settings have changed since the last tour calculation.
 */
export const captureSettingsSnapshot = (state: RootState): SettingsSnapshot => {
    // Exclude `isInRange` from waypoints as it's a derived value that changes
    // when selecting alternative routes, not an actual user setting change.
    const waypointsWithoutRange = state.search.waypoints.map(({ isInRange, ...rest }) => rest);

    return {
        vehicleProfile: JSON.stringify(state.vehicleProfile),
        search: JSON.stringify(waypointsWithoutRange),
        charging: JSON.stringify(state.charging),
        route: JSON.stringify(state.route),
    };
};

/**
 * Compares the current state against a previously captured snapshot.
 * Returns true if any settings have changed.
 */
export const hasSettingsChanged = (state: RootState, snapshot?: SettingsSnapshot): boolean => {
    if (!snapshot) {
        return false;
    }

    const current = captureSettingsSnapshot(state);
    return (
        current.vehicleProfile !== snapshot.vehicleProfile ||
        current.search !== snapshot.search ||
        current.charging !== snapshot.charging ||
        current.route !== snapshot.route
    );
};
